import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { STORES } from "../data/siteData";

const LINKS = [
  { label: "Contatti", to: "/contatti", testid: "footer-link-contatti" },
  { label: "Promozioni", to: "/promozioni", testid: "footer-link-promozioni" },
  { label: "Privacy Policy", to: "/privacy", testid: "footer-link-privacy" },
  { label: "Cookie Policy", to: "/cookie-policy", testid: "footer-link-cookie" },
  { label: "Gioco Responsabile", to: "/gioco-responsabile", testid: "footer-link-gioco-responsabile" },
  { label: "Informazioni Legali", to: "/note-legali", testid: "footer-link-note-legali" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-ink text-slate-300">
      <div className="container-x grid gap-12 py-16 md:grid-cols-3">
        <div>
          <p className="font-display text-2xl font-extrabold tracking-tight text-white">
            SISAL&nbsp;STORE<span className="text-brand">.</span>
          </p>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-slate-400">
            Sito informativo dei nostri tre punti vendita Sisal Store sul territorio.
            Questo non è il sito istituzionale ufficiale di Sisal S.p.A.
          </p>
          <div className="mt-6 inline-flex items-center gap-3">
            <span
              data-testid="footer-18-badge"
              className="flex h-10 w-10 items-center justify-center rounded-lg border-2 border-slate-500 font-display text-sm font-bold text-white"
            >
              18+
            </span>
            <p className="max-w-[240px] text-xs leading-snug text-slate-500">
              Il gioco è vietato ai minori di 18 anni e può causare dipendenza patologica.
            </p>
          </div>
        </div>

        <div>
          <p className="font-display text-sm font-bold uppercase tracking-[0.2em] text-white">
            Le nostre sedi
          </p>
          <ul className="mt-5 space-y-4">
            {STORES.map((s) => (
              <li key={s.id}>
                <Link
                  to={s.slug}
                  data-testid={`footer-store-${s.id}`}
                  className="group flex items-start gap-3 text-sm transition-colors hover:text-white"
                >
                  <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brand" />
                  <span>
                    <span className="font-semibold text-slate-200 group-hover:text-white">
                      {s.shortName}
                    </span>
                    <span className="block text-slate-400">{s.address}</span>
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-display text-sm font-bold uppercase tracking-[0.2em] text-white">
            Link utili
          </p>
          <ul className="mt-5 space-y-3">
            {LINKS.map((l) => (
              <li key={l.testid}>
                <Link
                  to={l.to}
                  data-testid={l.testid}
                  className="text-sm text-slate-400 transition-colors hover:text-white"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-x space-y-3 py-6">
          <p className="text-xs leading-relaxed text-slate-500">
            [PLACEHOLDER — AVVERTENZE OBBLIGATORIE] Spazio riservato alle diciture e alle
            avvertenze obbligatorie applicabili al gioco con vincita in denaro. Il testo
            definitivo verrà inserito qui.
          </p>
          <p className="text-xs text-slate-500">
            © {new Date().getFullYear()} Sisal Store — Mestre · Padova · Sant'Angelo di Piove di Sacco.
            Tutti i diritti riservati.
          </p>
        </div>
      </div>
    </footer>
  );
}
